import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    return {
        templating: state.template,
        itemsInBadge: state.shoppingBag.useBadge,
    }
}

export default connect(mapStateToProps)
